import { RichTextSchema, StoryblokVue } from '@storyblok/vue'
import { normalizeStoryblokRichTextLink } from '~~/shared/storyblok-link'
import { defineNuxtPlugin } from '#app'

// Replaces @storyblok/nuxt's built-in plugin (skipped via enableSudoMode in
// nuxt.config.ts). The built-in one force-loads apiPlugin, which requires an
// access token that the module then serializes into runtimeConfig.public —
// shipping it to every visitor. This app never calls the Storyblok API from
// the client (all content flows through server/api/*), so initialize without
// apiPlugin: StoryblokVue still registers the `v-editable` directive and the
// global <StoryblokComponent>, creates the richtext resolver renderRichText()
// needs, and keeps the Visual Editor bridge loader working. A client-side
// useStoryblokApi() call now fails loudly — add a server route instead.
export default defineNuxtPlugin(({ vueApp }) => {
    vueApp.use(StoryblokVue, {
        use: [],
        richText: {
            schema: {
                nodes: RichTextSchema.nodes,
                marks: {
                    ...RichTextSchema.marks,
                    link: mark => RichTextSchema.marks.link(normalizeStoryblokRichTextLink(mark)),
                },
            },
        },
    })
})
